import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import { LossCodeCategoryAction, useLossCodeCategoryProvider } from '../LossCodeCategory.Hooks';

export default function LossCodeCategoryList() {
  const { lang } = getLocales();
  const { listApi, pageRouter, permissions } = useLossCodeCategoryProvider();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.lossCodeCategories}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple} data-loading={listApi.isExecuting ? true : undefined}>
      <thead>
        <tr>
          <th>{lang.categoryNameEn}</th>
          <th>{lang.categoryNameFr}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: lossCodeCategory }) => (
            <tr key={lossCodeCategory.id}>
              <td>
                <b>{lossCodeCategory.nameEn ?? 'N/A'}</b>
              </td>
              <td>{lossCodeCategory.nameFr}</td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: lossCodeCategory.id.toString(),
                      action: LossCodeCategoryAction.EDIT,
                    }}
                    disabled={!permissions.EDIT_LOSSCODECATEGORY}
                    active
                    class={ThemeButtonCircle}
                    htmlElementProps={{
                      title: lang.edit,
                    }}
                    media={<Icon class="fas-edit" />}
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: lossCodeCategory.id.toString(),
                      action: LossCodeCategoryAction.DELETE,
                    }}
                    disabled={!permissions.DELETE_LOSSCODECATEGORY}
                    active
                    class={ThemeButtonCircle}
                    htmlElementProps={{
                      title: lang.delete,
                    }}
                    media={<Icon class="fas-trash" />}
                  />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
